module.exports = __webpack_public_path__ + "static/media/img-checkmark-gradient-l-new.ede0395f.svg";